const $fetch = async (
  {
    ctx,
    method,
    body,
    headers,
    parser = (res) => { return res.json() }
  },
  url
) => {
  if(ctx) ctx.$store.commit('AddLoading', url)
  if(headers === undefined) {
    headers = {
      'content-type': 'application/json'
    }
  }
  let settings = {
    method: method ? method : 'GET',
    body: body ? JSON.stringify(body) : null
  }
  if(headers) settings.headers = headers
  let results = null
  try {
    results = await fetch(url, settings)
    .then(res => parser(res))
    .catch(err => {
      if(ctx) ctx.$store.state.ERRORS.push(err.message)
    })
  } catch(err) {
    if(ctx) ctx.$store.state.ERRORS.push(err.message)
  }
  if(ctx) ctx.$store.commit('RemoveLoading', url)
  return results
}

export default $fetch